module.exports = __webpack_public_path__ + "img/sffb.4b7a1b46.png";